import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  FETCH_ALL_CONSULTATION,
  FILTER_CONSULTATION,
  UPDATE_CONSULTATION,
  DELETE_CONSULTATION,
  FETCH_CHATS,
  FETCH_CALLS,
} from "constants/consultation.constants";
import axios from "axios";
import {
  fetchConsultationsSuccess,
  filterConsultationsSuccess,
  updateConsultationSuccess,
  deleteConsultationSuccess,
  fetchChatsSuccess,
  fetchCallsSuccess,
} from "actions/consultations.action";
import { showErrors, stopLoader } from "actions/general.action";
import { chatInstance } from "sagas";

// consultation sagas

const fetchConsultationsRequest = async (page) => {
  return chatInstance.get("/api/v1/super_admin/web/rooms?page=" + page);
};

function* fetchConsultations({ payload }) {
  try {
    const reuslt = yield call(fetchConsultationsRequest, payload);
    if (reuslt.message) {
      yield put(showErrors(reuslt.message));
    } else {
      yield put(fetchConsultationsSuccess(reuslt.data));
      yield put(stopLoader());
    }
  } catch (error) {
    yield put(showErrors(error.message));
  }
}

const filterConsultationsRequest = async (payload) => {
  if(payload.value==undefined||payload.value==''){
    return chatInstance.get(
      "/api/v1/super_admin/web/rooms?page=" + payload.page 
    );
  }
  return chatInstance.get(
    "/api/v1/super_admin/web/rooms?page=" + payload.page + "&" + payload.key + "=" + payload.value
  );
};

function* filterConsultations({ payload }) {
  try {
    const result = yield call(filterConsultationsRequest, payload);

    if (result.message) {
      yield put(showErrors(result.message));
    } else {
      yield put(filterConsultationsSuccess(result.data));
      yield put(stopLoader());
    }
  } catch (error) {
    yield put(showErrors(error.message));
  }
}
const updateConsultationsRequest = async (payload) => {
  let o = Object.assign({}, payload);
  o.partner_type = { id: payload.consultation_type_id };
  o.country = { id: payload.country_id };

  return axios.put("/api/v1/super_admin/consultations/" + payload.id, o);
};

function* updateConsultation({ payload }) {
  try {
    const reuslt = yield call(updateConsultationsRequest, payload);
    if (reuslt.message) {
      yield put(showErrors(reuslt.message));
    } else {
      yield put(updateConsultationSuccess(reuslt.data));
      yield put(stopLoader());
    }
  } catch (error) {
    yield put(showErrors(error.message));
  }
}

const createConsultationsRequest = async (payload) => {
  let o = {
    consultation_type: { id: payload.consultation_type_id },
    name: payload.name,
  };

  o.selected_sub_consultations = [];
  console.log(payload);
  payload.ids.forEach(function(sub) {
    let d = {
      sub_consultation: {
        id: sub,
      },
      consultation_type: {
        id: payload.consultation_type_id,
      },
    };
    if (sub === 1) {
      let op = {
        video_consult_limit: payload.video_consult_limit,
        video_limit_condition_period: payload.video_limit_condition_period,
        video_specialities: payload.video_specialities,
      };
      d["option"] = op;
    } else if (sub === 3) {
      let op = {
        chat_limit_needed: payload.chat_limit_needed,
        duration_before_consult: payload.duration_before_consult,
        duration_after_consult: payload.duration_after_consult,
      };
      d["option"] = op;
    } else if (sub === 4) {
      let op = {
        translator_second_lang: payload.translator_second_lang,
        translator_first_lang: payload.translator_first_lang,
      };
      d["option"] = op;
    }
    o.selected_sub_consultations.push(d);
  });
  console.log(o);
  return axios.post("/api/v1/super_admin/consultations", o);
};

const deleteConsultationsRequest = async (id) => {
  return axios({
    method: "delete",
    url: "/api/v1/super_admin/consultations/" + id,
    headers: {
      'Content-Type': 'text/plain'
    },
    data: "",
  });
};

function* deleteConsultation({ payload }) {
  try {
    const reuslt = yield call(deleteConsultationsRequest, payload);
    if (!reuslt.status) {
      yield put(showErrors(reuslt.message));
    } else {
      yield put(deleteConsultationSuccess(reuslt.data));
      yield put(stopLoader());
    }
  } catch (error) {
    yield put(showErrors(error.message));
  }
}

const fetchChatsRequest = async (payload) => {
  return chatInstance.get(
    "/api/v1/super_admin/web/chats?room_id=" + payload.room_id + "&page=" + payload.page
  );
};

function* fetchChats({ payload }) {
  try {
    const result = yield call(fetchChatsRequest, payload);
    if (result.message) {
      yield put(showErrors(result.message));
    } else {
      yield put(fetchChatsSuccess(result.data));
      yield put(stopLoader());
    }
  } catch (error) {
    yield put(showErrors(error.message));
  }
}

const fetchCallsRequest = async (payload) => {
  return chatInstance.get("/api/v1/super_admin/web/callevents?room_id=" + payload.room_id);
};

function* fetchCalls({ payload }) {
  try {
    const result = yield call(fetchCallsRequest, payload);
    if (result.message) {
      yield put(showErrors(result.message));
    } else {
      yield put(fetchCallsSuccess(result.data));
      yield put(stopLoader());
    }
  } catch (error) {
    yield put(showErrors(error.message));
  }
}

// fork consultation
export function* forkFetchConsultations() {
  yield takeEvery(FETCH_ALL_CONSULTATION, fetchConsultations);
}

export function* forkFilterConsultations() {
  yield takeEvery(FILTER_CONSULTATION, filterConsultations);
}

export function* forkUpdateConsultation() {
  yield takeEvery(UPDATE_CONSULTATION, updateConsultation);
}

export function* forkDeleteConsultation() {
  yield takeEvery(DELETE_CONSULTATION, deleteConsultation);
}

// fork chats
export function* forkFetchChats() {
  yield takeEvery(FETCH_CHATS, fetchChats);
}

// fork calls
export function* forkFetchCalls() {
  yield takeEvery(FETCH_CALLS, fetchCalls);
}

export default function* rootSaga() {

  yield all([
    fork(forkFetchConsultations),
    fork(forkFilterConsultations),
    //fork(forkUpdateConsultation),
    fork(forkDeleteConsultation),
    fork(forkFetchChats),
    fork(forkFetchCalls),
  ]);
}

